import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { X } from "lucide-react";

const galleryImages = [
  {
    src: "https://images.unsplash.com/photo-1622323589314-d46bced463a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkYXl0b25hJTIwYmVhY2glMjBwaWVyJTIwb2NlYW4lMjBzdW5zZXR8ZW58MHx8fHwxNzcyMTI1MjkwfDA&ixlib=rb-4.1.0&q=85",
    caption: "Daytona Beach at golden hour",
    rotate: "rotate-1",
  },
  {
    src: "https://images.unsplash.com/photo-1654483344665-4c281a28c6cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxkYXl0b25hJTIwYmVhY2glMjBwaWVyJTIwb2NlYW4lMjBzdW5zZXR8ZW58MHx8fHwxNzcyMTI1MjkwfDA&ixlib=rb-4.1.0&q=85",
    caption: "Sunset over the pier",
    rotate: "-rotate-2",
  },
  {
    src: "https://images.unsplash.com/photo-1645409229592-24de3932f10a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxkYXl0b25hJTIwYmVhY2glMjBwaWVyJTIwb2NlYW4lMjBzdW5zZXR8ZW58MHx8fHwxNzcyMTI1MjkwfDA&ixlib=rb-4.1.0&q=85",
    caption: "Beach vibes all day",
    rotate: "rotate-2",
  },
  {
    src: "https://images.unsplash.com/photo-1763616310394-b8ed0a3318c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb2xvcmZ1bCUyMGJlZHJvb20lMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzIxMjUyOTF8MA&ixlib=rb-4.1.0&q=85",
    caption: "The Wave Rider room",
    rotate: "-rotate-1",
  },
  {
    src: "https://images.pexels.com/photos/3754595/pexels-photo-3754595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "The Lighthouse suite",
    rotate: "rotate-3",
  },
  {
    src: "https://images.pexels.com/photos/18435276/pexels-photo-18435276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Our beachfront home",
    rotate: "-rotate-2",
  },
  {
    src: "https://images.unsplash.com/photo-1674042385136-28d23ca038ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGJlZCUyMGJyZWFrZmFzdCUyMGNvenklMjByb29tfGVufDB8fHx8MTc3MjEyNTQzM3ww&ixlib=rb-4.1.0&q=85",
    caption: "Breakfast in bed — always an option",
    rotate: "rotate-1",
  },
  {
    src: "https://images.pexels.com/photos/9400906/pexels-photo-9400906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Aerial view of the coastline",
    rotate: "-rotate-1",
  },
  {
    src: "https://images.unsplash.com/photo-1654284392067-10486b12edc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxkYXl0b25hJTIwYmVhY2glMjBmbG9yaWRhJTIwb2NlYW4lMjBzdW5yaXNlfGVufDB8fHx8MTc3MjEyNTQyNnww&ixlib=rb-4.1.0&q=85",
    caption: "Sunrise reflections",
    rotate: "rotate-2",
  },
  {
    src: "https://images.unsplash.com/photo-1687941544146-351d41b57cbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb2xvcmZ1bCUyMGJlZHJvb20lMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzIxMjUyOTF8MA&ixlib=rb-4.1.0&q=85",
    caption: "The Sandcastle room",
    rotate: "-rotate-3",
  },
  {
    src: "https://images.pexels.com/photos/12397457/pexels-photo-12397457.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Daytona sunrise palette",
    rotate: "rotate-1",
  },
  {
    src: "https://images.unsplash.com/photo-1654284392097-920f2c1cc25c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxkYXl0b25hJTIwYmVhY2glMjBmbG9yaWRhJTIwb2NlYW4lMjBzdW5yaXNlfGVufDB8fHx8MTc3MjEyNTQyNnww&ixlib=rb-4.1.0&q=85",
    caption: "Evening stroll on the beach",
    rotate: "-rotate-1",
  },
];

export default function GalleryPage() {
  const [selected, setSelected] = useState(null);

  return (
    <div data-testid="gallery-page">
      {/* Hero */}
      <section className="relative bg-ink py-20">
        <div className="noise-overlay absolute inset-0" />
        <div className="relative z-10 mx-auto max-w-7xl px-6">
          <p className="font-marker text-teal text-sm">The Wall</p>
          <h1 className="mt-2 font-anton text-4xl tracking-wider text-sand stencil-text sm:text-6xl">
            GALLERY
          </h1>
          <div className="mt-2 h-1 w-20 bg-coral" />
          <p className="mt-4 font-courier text-sm text-sand/70 max-w-lg">
            Snapshots from around the property and our beautiful backyard — Daytona Beach.
            Every image tells a story. Click to zoom.
          </p>
        </div>
      </section>

      {/* Gallery Grid - Polaroid Wall */}
      <section className="bg-sand py-16">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {galleryImages.map((img, i) => (
              <button
                key={i}
                data-testid={`gallery-image-${i}`}
                onClick={() => setSelected(img)}
                className={`polaroid ${img.rotate} cursor-pointer text-left`}
              >
                <img
                  src={img.src}
                  alt={img.caption}
                  className="aspect-square w-full object-cover"
                  loading="lazy"
                />
                <p className="mt-2 font-marker text-ink text-xs text-center">
                  {img.caption}
                </p>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Dialog */}
      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent
          className="max-w-4xl border-2 border-ink bg-sand p-2 sm:p-4 shadow-brutal-lg"
          data-testid="gallery-lightbox"
        >
          <DialogTitle className="sr-only">
            {selected?.caption || "Gallery image"}
          </DialogTitle>
          <DialogDescription className="sr-only">
            Full size view of gallery image
          </DialogDescription>
          {selected && (
            <div>
              <img
                src={selected.src}
                alt={selected.caption}
                className="w-full object-contain max-h-[70vh]"
              />
              <p className="mt-3 font-marker text-ink text-center text-sm">
                {selected.caption}
              </p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
